import React, { useRef } from 'react'
import { Bar } from 'react-chartjs-2'
import { Grid, Typography, Paper, Divider, } from '@mui/material'
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

/** 
 * 
 * This component is expecting the following input. 


*/

const AdminCompletionGraph = (props) => {
    const componentdata = [...props.component.Values].sort((a, b) => { return parseInt(a.Order) - parseInt(b.Order) })
    const chartRef = useRef(null);
    let graphcolors = ['#4eb748', '#E7C61E', '#9A3218', '#c0c0c0']
    const lables = ['Participation Graph']


    const dataset = componentdata.map(val => {
        return {
            label: [val.Order === '10' ? 'Completed' : val.Order === '20' ? 'In Progress' : 'Not Participating']
            , data: [parseInt(val.SegmentLabel1)]
            , number: [parseInt(val.SegmentLabel2)]
            , backgroundColor: [val.Color]
            , barThickness: 12

        }
    }).filter(n => n)



    const sum = (key) => {
        return this.reduce((a, b) => a + (b[key] || 0), 0);
    }
    // if max isnt defined, the bar will not be the appropriate length
    const MaxValue = dataset.reduce((a, b) => a + parseInt(b.data[0], 0), 0)

    // dynamically create grid / center values    
    const GridDisplay_Bottom = () => {
        return (
            <Grid container columns={dataset.length * 5} direction="row" alignItems="center" justifyContent="center">
                {
                    dataset.map((x, i) => {
                        return (
                            <Grid item xs={5}>
                                <Grid container direction="row" alignItems="center" justifyContent="center">
                                    <Grid item xs={10}>
                                        <Typography variant="body2" align="center" fontWeight="bold" color={x.backgroundColor[0]}>{x.label[0]}</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography variant="body2" align="center" fontWeight="bold" color={x.backgroundColor[0]}>({x.number[0]})</Typography>

                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    })
                }
            </Grid>
        )
    }


    const data = {
        labels: lables,
        datasets: dataset
    }

    const config = {
        type: 'bar',
        data: data,
        animation: { duration: 0 },

        options: {
            indexAxis: 'y',
            maintainAspectRatio: false,
            scales: {
                y: {
                    beginAtZero: true,
                    max: MaxValue,
                    grid: {
                        display: false //turns off grid lines
                        , drawBorder: false  //turns off border lines
                    },
                    ticks: {
                        display: false // turns off values on axis
                    }
                    , stacked: true

                },
                x: {
                    max: MaxValue,
                    grid: {
                        display: false //turns off grid lines
                        , drawBorder: false  //turns off border lines
                    }
                    , ticks: {
                        display: false // turns off values on axis
                    }
                    , stacked: true
                }
            },
            plugins: {
                legend: {
                    display: false
                }
            },

        }
    }
    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }


    return (
        <Grid item lg={12} md={12} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
            <motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>

                <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px', height: '100%' }}>
                    <Grid container direction="row" alignItems="center" justifyContent="center" spacing={0}>
                        <Grid item xs={12} >
                            <Typography variant="h4" align="center">Overview</Typography>
                        </Grid>
                        <Grid item xs={12} m={1}>
                            <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2, m:1 }} />
                        </Grid>
                        {/* <Grid item xs={12}>
                        <Typography variant="h5" align="center">{props.component.Label}</Typography>
                    </Grid>
                    <Grid item xs={12} m={1}>
                        <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                    </Grid> */}
                        <Grid item xs={12} >
                            <Grid container columns={MaxValue + dataset.length} direction="row" alignItems="center" justifyContent="center">
                                {
                                    dataset.map((x, i) => {

                                        return (
                                            <Grid item xs={x.data[0] + 1}>
                                                <Typography variant="body2" align="center" fontWeight="bold" color={x.backgroundColor[0]}>{Math.floor((x.data[0] / MaxValue) * 100) == 0 ? "" : String(Math.floor((x.data[0] / MaxValue) * 100)) + "%" }</Typography>
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </Grid>
                        <Grid item xs={12} alignItems="center" justifyContent="center" sx={{ height: "50px", width: "100%" }}>
                            <Bar
                                ref={chartRef}
                                data={data}
                                options={config.options}
                            //onClick={handleScrollToSection}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container columns={dataset.length * 5} direction="row" alignItems="center" justifyContent="center">
                                {
                                    dataset.map((x, i) => {
                                        return (
                                            <Grid item xs={5}>
                                                <Grid container direction="row" alignItems="center" justifyContent="center">
                                                    <Grid item xs={9}>
                                                        <Typography variant="body2" align="right" fontWeight="bold" color={x.backgroundColor[0]}>{x.label[0]}</Typography>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Typography variant="body2" align="left" fontWeight="bold" color={x.backgroundColor[0]}>({x.number[0]})</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                </Paper>
            </motion.div>
        </Grid>
    )
}

export default AdminCompletionGraph